/**
 * Ajuda dos campos da administracao da plataforma.
 *
 * Juntada em `../ajudaDosCampos.ts`, que explica a chave e o texto. Ver
 * docs/FRONTEND.md, secao 6.
 *
 * O /admin fica fora do menu da empresa, e o dicionario so aceita rotas do menu. Por
 * isso a ajuda da configuracao de plataforma da empresa (P-PLAT) fica aqui, em
 * `ajudaDaConfiguracaoDePlataforma`, e a tela a passa ao campo, como o painel de
 * documentos faz com a dele.
 */
export const ajudaDaConfiguracaoDePlataforma = {
  'Limite de sinistros por mes':
    'Vazio e sem limite. So e gravado: o que o limite conta ainda nao tem fonte, e nada e bloqueado por ele.',
  'Cota de disco (GB)':
    'Cota em gigabytes de 1024^3 bytes. Soma documentos, excluidos guardados, modelos e documentos gerados. Vazio e sem cota.',
  'Ambiente do portal (JSON)':
    'Um objeto JSON de ate 64 KB. Vazio e sem configuracao. So e gravado: o conteudo ainda nao tem fonte.',
} as const;

/** Ajuda dos campos de Configuracoes > E-mail (ADR 0096). */
export const ajudaDoEmailDaPlataforma = {
  Servidor:
    'Nome do servidor SMTP, sem protocolo e sem porta, como mail.exemplo.com.br. O certificado do servidor e sempre conferido.',
  Seguranca:
    'SSL implicito usa TLS desde o inicio (porta 465). STARTTLS sobe para TLS antes da senha (porta 587); o servidor que nao oferece STARTTLS e recusado. Sem TLS nao ha envio.',
  Senha:
    'Gravada cifrada com a chave de segredos do servidor e nunca mostrada. Deixe em branco para manter a senha gravada.',
  'Prazo de envio (segundos)':
    'Tempo maximo da conversa com o servidor de e-mail, de 5 a 25 segundos. O envio acontece dentro do pedido de quem usa a tela.',
} as const;

export const ajuda: Record<string, Record<string, string>> = {};
